import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { NoteContentDocumentVersionInspector } from "@/pages/notes/components/note-content-document-snapshots/version-inspector";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { Button, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import styled from "@emotion/styled";

export const NotesSnapshotsPage: FC = () => {
  const { noteId } = useParams<{ noteId: Uuid }>();
  const navigate = useNavigate();

  if (!noteId) {
    return <div>Invalid ID</div>;
  }

  const noteResult = useQuery({
    queryKey: ["note", noteId],
    queryFn: () =>
      api.get("/internal/v1/notes/{note_id}", {
        params: {
          path: {
            note_id: noteId,
          },
        },
      }),
  });

  return (
    <Container>
      <Flex justify="between" align="center" mb="4">
        <h1>Note History</h1>
        <Button onClick={() => navigate(atlasRoutes.notesView({ params: { noteId } }).path)}>
          Back to Note
        </Button>
      </Flex>
      {noteResult.data?.data && (
        <div>
          <h3>{noteResult.data.data.primary_label}</h3>
          {noteResult.data.data.secondary_label && <h4>{noteResult.data.data.secondary_label}</h4>}
        </div>
      )}
      <hr />
      <br />
      <br />
      <NoteContentDocumentVersionInspector noteId={noteId} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;
